import React, { Component } from 'react'
import footer_shape from '../../images/footer-shape.webp'
import logo_footer from '../../images/logoWhite.png'
import FacebookSvg from '../icons/FacebookSvg'
import InstagramSvg from '../icons/InstagramSvg'
import LinkedinSvg from '../icons/LinkedinSvg'
import TelegramSvg from '../icons/TelegramSvg'
import { Link } from 'react-router-dom'
import RightSvg from '../icons/RightSvg'
import LetterSvg from '../icons/LetterSvg'
import LocationsSvg from '../icons/LocationsSvg'
import PhoneSvg from '../icons/PhoneSvg'

export class Footer extends Component {
    render() {
        return (
            <footer className='bg-[#2e2f46] p-[52px_0px] max-[580px]:p-[32px_0]'>
                <div className=''>
                    <div className='relative'>
                        {/* Shape resmini yerleştiriyoruz */}
                        <div className='absolute top-0 left-0 w-full h-[80%] z-0'>
                            <img src={footer_shape} className='w-full h-full object-cover' alt="Footer Shape" />
                        </div>

                        {/* İçerik kısmı */}
                        <div className='relative z-10 w-full  container'>
                            <div className='flex items-start justify-between gap-[120px] w-full max-[1100px]:flex-col max-[1100px]:items-center max-[1100px]:gap-[50px]'>

                                <div className='flex items-start justify-between w-[50%] max-[1100px]:w-full max-[1100px]:gap-[50px] max-[580px]:flex-col ' id='first_2cards'>

                                    <div className='flex flex-col gap-[24px] items-start  max-[1100px]:w-[50%] max-[580px]:w-full '>
                                        <div>
                                            <img src={logo_footer} className='w-[230px] h-[100px] rounded-[8px]' />
                                        </div>

                                        <div className='max-w-[376px] '>
                                            <p className='text-[16px] font-[500] text-[#ccc]'>
                                                © 2024 All Rights Reserved
                                            </p>
                                        </div>

                                        {/* <div className='flex items-center gap-[12px]'>
                                            <div className='bg-[#393a4f] p-[20px] rounded-[50px] max-[880px]:p-[15px]'>
                                                <FacebookSvg width="20" height="20" fill="#fff" />
                                            </div>
                                            <div className='bg-[#393a4f] p-[19px] rounded-[50px] max-[880px]:p-[14px]'>
                                                <InstagramSvg height="22" width="22" />
                                            </div>
                                            <div className='bg-[#393a4f] p-[22px] rounded-[50px] max-[880px]:p-[17px]'>
                                                <LinkedinSvg />
                                            </div>
                                            <div className='bg-[#393a4f] p-[17px] rounded-[50px] max-[880px]:p-[12px]'>
                                                <TelegramSvg />
                                            </div>
                                        </div> */}
                                    </div>

                                    <div className='flex flex-col gap-[30px] max-[1100px]:items-start max-[1100px]:w-[50%] max-[580px]:w-full '>
                                        <div>
                                            <h3 className='text-[30px] text-[#fff] font-[700] max-[880px]:text-[24px]'>Səhifələr</h3>
                                        </div>

                                        <ul className='flex flex-col ml-[5px] gap-[18px]'>
                                            <li className='text-[#fff] font-[500] text-[16px]'>
                                                <Link to="/" className='flex items-center gap-[4px]'> <RightSvg fill="#fff" width="16" height="16" /> Ana Səhifə </Link>
                                            </li>
                                            <li className='text-[#fff] font-[500] text-[16px]'>
                                                <Link to="/about-us" className='flex items-center gap-[4px]'> <RightSvg fill="#fff" width="16" height="16" /> Haqqımızda </Link>
                                            </li>
                                            <li className='text-[#fff] font-[500] text-[16px]'>
                                                <Link to="/project" className='flex items-center gap-[4px]'> <RightSvg fill="#fff" width="16" height="16" /> Portfolio </Link>
                                            </li>
                                            <li className='text-[#fff] font-[500] text-[16px]'>
                                                <Link to="/services" className='flex items-center gap-[4px]'> <RightSvg fill="#fff" width="16" height="16" /> Xidmətlərimiz </Link>
                                            </li>
                                            <li className='text-[#fff] font-[500] text-[16px]'>
                                                <Link to="/blogs" className='flex items-center gap-[4px]'> <RightSvg fill="#fff" width="16" height="16" /> Bloq </Link>
                                            </li>
                                            <li className='text-[#fff] font-[500] text-[16px]'>
                                                <Link to="/contact-us" className='flex items-center gap-[4px]'> <RightSvg fill="#fff" width="16" height="16" /> Əlaqə </Link>
                                            </li>
                                        </ul>
                                    </div>

                                </div>

                                <div className='flex items-start  w-[45%] gap-[120px] max-[1100px]:w-full max-[1100px]:justify-between max-[1100px]:gap-[50px] max-[580px]:flex-col '>

                                    <div className='flex flex-col gap-[30px] max-[1100px]:w-[50%] max-[580px]:w-full '>
                                        <div>
                                            <h3 className='text-[30px] text-[#fff] font-[700] max-[880px]:text-[24px]'>Xidmətlərimiz</h3>
                                        </div>

                                        <ul className='flex flex-col ml-[5px] gap-[18px] min-w-[150px]'>
                                            <li className='text-[#fff] font-[500] text-[16px]'>
                                                <Link className='flex items-center gap-[4px]'> <RightSvg fill="#fff" width="16" height="16" /> Web Sayt Dizaynı </Link>
                                            </li>
                                            <li className='text-[#fff] font-[500] text-[16px]'>
                                                <Link className='flex items-center gap-[4px]'> <RightSvg fill="#fff" width="16" height="16" />Web Sayt Kodlaşdırılması </Link>
                                            </li>
                                            <li className='text-[#fff] font-[500] text-[16px]'>
                                                <Link className='flex items-center gap-[4px]'> <RightSvg fill="#fff" width="16" height="16" /> SEO Xidmətləri </Link>
                                            </li>
                                            <li className='text-[#fff] font-[500] text-[16px]'>
                                                <Link className='flex items-center gap-[4px]'> <RightSvg fill="#fff" width="16" height="16" /> E-ticarət Saytları </Link>
                                            </li>
                                            <li className='text-[#fff] font-[500] text-[16px]'>
                                                <Link className='flex items-center gap-[4px]'> <RightSvg fill="#fff" width="16" height="16" /> Veb Tətbiq Hazırlanması </Link>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className='flex flex-col gap-[30px] max-[1100px]:w-[50%]  max-[580px]:w-full'>
                                        <div>
                                            <h3 className='text-[30px] text-[#fff] font-[700] max-[880px]:text-[24px]'>Əlaqə</h3>
                                        </div>

                                        <div className='flex flex-col gap-[20px] '>
                                            <div className='flex flex-col gap-[7px]'>
                                                <div className='flex items-center gap-[12px]'>
                                                    <LetterSvg />

                                                    <h3 className='text-[16px] text-[#fff] font-[600]'>
                                                        Email
                                                    </h3>
                                                </div>

                                                <div className='ml-[28px]'>
                                                    <Link to="mailto:info@itnova.az" className='text-[#CCCCCC] text-[15px] font-[500] hover:text-[#EE7100]'>info@itnova.az</Link>
                                                </div>
                                            </div>

                                            <div className='flex flex-col gap-[7px]'>
                                                <div className='flex items-center gap-[12px]'>
                                                    <LocationsSvg className="footer-svg" />

                                                    <h3 className='text-[16px] text-[#fff] font-[600]'>
                                                        Ünvan
                                                    </h3>
                                                </div>

                                                <div className='ml-[28px]'>
                                                    <Link className='text-[#CCCCCC] text-[15px] font-[500] hover:text-[#EE7100]'>Baku, Xocalı pr.14</Link>
                                                </div>
                                            </div>


                                            <div className='flex flex-col gap-[7px]'>
                                                <div className='flex items-center gap-[12px]'>
                                                    <PhoneSvg
                                                        fill="none"
                                                        className="footer-svg"
                                                    />

                                                    <h3 className='text-[16px] text-[#fff] font-[600]'>
                                                        Nömrə
                                                    </h3>
                                                </div>

                                                <div className='ml-[28px]'>
                                                    <Link to="tel:+994706562202" className='text-[#CCCCCC] text-[15px] font-[500] hover:text-[#EE7100]'>+994 70 656 22 02</Link>
                                                </div>
                                            </div>




                                        </div>
                                    </div>
                                </div>



                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer